import "../../../resources/fonts/fonts.css"


    export const DataGridWrapperStyles = {
        width: "100%",
        height: 550
    }

    export const DataGridStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) => 
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(",")
    }

    export const DialogStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["Century "].join(",")
    }

    export const ButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        textTransform: "none",
        fontFamily: ["Century "].join(",")
    }

    export const ContainedButtonStyles = {
        color: "black ",
        textTransform: "none",
        fontFamily: ["Century "].join(",")
    }

    export const MaintenanceTitleStyles = {
        paddingBottom: "15px",
        fontWeight: "bold",
        fontFamily: ["Century "].join(",")
    }

    export const ColumnBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }

    export const MainBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }

    export const ColumnBoxBorderStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid black"
    }

    export const RowBoxBorderStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        border: "1px solid black"
    }

    export const RowBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    }

    export const HeatMapBoxStyles = {
        justifyContent: "left",
        alignContent: "left"
    }

    export const AuditGridBoxStyles = {
        width: "90vw",
        height: "63vh",
        marginRight: "10px",
        marginLeft: "10px",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    }

    export const LabelStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["Century "].join(","),
        fontWeight: "bold",
        textAlign: "left"
    }
